// src/screens/auth/Login.jsx

import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { MdEmail, MdLock, MdVisibility, MdVisibilityOff } from "react-icons/md";
import { FaLeaf } from "react-icons/fa";
import Button from "../../../components/general/button/Button";
import "../../../assets/css/admin/auth/AdminLogin.css";
import MyContext from "../../../context/MyContext";
import axios from "axios";

function AdminLogin() {
  const navigate = useNavigate();
  const { baseUrl, setAuthToken, setLoggedInAdmin } = useContext(MyContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errormessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  //////Auto login
  const [rememberMe, setRememberMe] = useState(false);

  const autoLogin = (savedEmail, savedPassword) => {
    setLoading(true);

    const formdata = new FormData();
    formdata.append("email", savedEmail);
    formdata.append("password", savedPassword);

    axios
      .post(`${baseUrl}/admin/auth/login`, formdata)
      .then((response) => {
        console.log(response.data);
        if (!response.data.token) {
          setLoading(false);
          localStorage.removeItem("adminEmail");
          localStorage.removeItem("adminPassword");
        } else {
          setLoading(false);
          localStorage.setItem("authToken", response.data.token);
          setAuthToken(response.data.token);
          localStorage.setItem(
            "loggedInAdmin",
            JSON.stringify(response.data.admin),
          );
          setLoggedInAdmin(response.data.admin);
          navigate("/admin");
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        localStorage.removeItem("adminEmail");
        localStorage.removeItem("adminPassword");
      });
  };

  const Login = () => {
    setLoading(true);
    setErrorMessage("");
    const formdata = new FormData();
    formdata.append("email", email);
    formdata.append("password", password);

    axios
      .post(`${baseUrl}/admin/auth/login`, formdata)
      .then((response) => {
        console.log(response.data);
        if (!response.data.token) {
          setErrorMessage("Invalid email or password");
          setLoading(false);
        } else {
          console.log("login successful", response.data);
          console.log(response.data.token);
          localStorage.setItem("authToken", response.data.token);
          setAuthToken(response.data.token);
          if (rememberMe) {
            localStorage.setItem("adminEmail", email);
            localStorage.setItem("adminPassword", password);
          }
          localStorage.setItem(
            "loggedInAdmin",
            JSON.stringify(response.data.admin),
          );
          setLoggedInAdmin(response.data.admin);
          setLoading(false);
          navigate("/admin");
        }
      })
      .catch((error) => {
        setErrorMessage("An error occurred. Please try again.");
        setLoading(false);
      });
  };
  useEffect(() => {
    const savedEmail = localStorage.getItem("adminEmail");
    const savedPassword = localStorage.getItem("adminPassword");
    console.log(savedEmail);
    console.log(savedPassword);
    if (savedEmail != null && savedEmail != "") {
      autoLogin(savedEmail, savedPassword);
    } else {
      setLoading(false);
    }
  }, []);

  return (
    <div className="km-auth-page">
      {loading ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255,255,255,0.9)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              width: "4rem",
              height: "4rem",
              border: "4px solid #097d43",
              borderTop: "4px solid transparent",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          ></div>
          <p style={{ marginTop: "15px", fontSize: "18px" }}>Logging in...</p>
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
      ) : (
        <Container fluid className="km-auth-container">
          <Row className="km-auth-row g-0">
            {/* Left Side - Branding */}
            <Col lg={6} className="km-auth-left">
              <div className="km-auth-branding">
                <div className="km-logo-section">
                  <div className="km-logo-circle">
                    <FaLeaf className="km-logo-icon" />
                  </div>
                  <h1 className="km-brand-name">Kisaan Mart</h1>
                </div>

                <div className="km-welcome-section">
                  <h2 className="km-welcome-title">Welcome Back!</h2>
                  <p className="km-welcome-text">
                    Login to access your admin dashboard and manage your
                    platform
                  </p>
                </div>

                <div className="km-features-list">
                  <div className="km-feature-item">
                    <div className="km-feature-check">✓</div>
                    <span>Manage Users</span>
                  </div>
                  <div className="km-feature-item">
                    <div className="km-feature-check">✓</div>
                    <span>Monitor Orders & Delivery</span>
                  </div>
                  <div className="km-feature-item">
                    <div className="km-feature-check">✓</div>
                    <span>Manage Topup</span>
                  </div>
                  <div className="km-feature-item">
                    <div className="km-feature-check">✓</div>
                    <span>Complete Platform Control</span>
                  </div>
                </div>
              </div>
            </Col>

            {/* Right Side - Login Form */}
            <Col lg={6} className="km-auth-right">
              <div className="km-form-wrapper">
                <div className="km-form-container">
                  <div className="km-form-header">
                    <h2 className="km-form-title">LogIn</h2>
                    <p className="km-form-subtitle">
                      Enter your credentials to continue
                    </p>
                  </div>

                  <form className="km-auth-form">
                    {/* Email Field */}
                    <div className="km-input-group">
                      <label className="km-input-label" htmlFor="email">
                        Email
                      </label>
                      <div className="km-input-wrapper">
                        <span className="km-input-icon">
                          <MdEmail />
                        </span>
                        <input
                          id="email"
                          type="email"
                          name="email"
                          className="km-input-field"
                          placeholder="admin@kisaanmart.com"
                          value={email}
                          onChange={(event) => setEmail(event.target.value)}
                          autoComplete="email"
                        />
                      </div>
                    </div>

                    {/* Password Field */}
                    <div className="km-input-group">
                      <label className="km-input-label" htmlFor="password">
                        Password
                      </label>
                      <div className="km-input-wrapper">
                        <span className="km-input-icon">
                          <MdLock />
                        </span>
                        <input
                          id="password"
                          type={showPassword ? "text" : "password"}
                          name="password"
                          className="km-input-field"
                          placeholder="Enter your password"
                          value={password}
                          onChange={(event) => setPassword(event.target.value)}
                          autoComplete="current-password"
                        />
                        <button
                          type="button"
                          className="km-password-toggle"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? (
                            <MdVisibilityOff />
                          ) : (
                            <MdVisibility />
                          )}
                        </button>
                      </div>
                    </div>

                    {/* Forgot Password Link */}
                    <div style={{ textAlign: "right", marginBottom: "1rem" }}>
                      <span
                        style={{
                          color: "#097d43",
                          cursor: "pointer",
                          fontSize: "0.875rem",
                        }}
                        onClick={() => navigate("/admin/forgot-password")}
                      >
                        Forgot password?
                      </span>
                    </div>

                    {/* Error Message */}
                    {errormessage && (
                      <div
                        style={{
                          color: "#dc3545",
                          fontSize: "0.875rem",
                          marginBottom: "1rem",
                          padding: "0.75rem",
                          background: "#fff3f3",
                          borderRadius: "8px",
                          border: "1px solid #ffdddd",
                        }}
                      >
                        {errormessage}
                      </div>
                    )}

                    {/* Submit Button */}
                    <Button
                      type="button"
                      variant="primary"
                      fullWidth
                      disabled={loading}
                      className="km-submit-btn"
                      onClick={Login}
                    >
                      {loading ? "Logging In..." : "Login"}
                    </Button>
                  </form>

                  {/* Footer */}
                  <div className="km-form-footer">
                    <p>© 2025 Kisaan Mart. All rights reserved.</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      )}
    </div>
  );
}

export default AdminLogin;
